/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */
import { Component } from '@appCanvasCommon/component-system/Component';
import { ComponentInterface } from '@appCanvasCommon/interfaces/component.interface';
import { EventBinder } from '@appPlanApplication/interaction';
import { CanvasAngularLand } from '../../../../app-data/interfaces/canvas-angular-land';
import { DisplayObject } from 'pixi.js-legacy';
import { IDestroyOptions } from '@appCanvasCommon/core/DestroyOptions';
import { EventMode } from '@appCanvasCommon/events/event-mode.enum';
import { CursorType } from '@appCanvasCommon/events/cursor-type.enum';
export class MilestoneTap extends Component implements ComponentInterface {
	private _binder: EventBinder;
	/**
	 * The setup method is called once all properties on a component have been decorated by the ComponentManager.
	 * From this point on, you can safely use this.getParent() and this.getManager().
	 * Arguments passed into setup are passed in via the ComponentManager.add(name, component, ...args)
	 */
	public override setup(canvasAngularLand: CanvasAngularLand, parent: DisplayObject): void {
		this.canvasAngularLand = canvasAngularLand;
		this._binder = new EventBinder(parent);
		parent.eventMode = EventMode.Static;
		parent.cursor = CursorType.Pointer;

		this._binder.add('hammer-singletap', (event) => {
			this.canvasAngularLand.milestoneLineService.showCalendar();
		});
	}

	public override destroy(opts?: IDestroyOptions) {
		super.destroy(opts);
		this._binder.destroy();
	}
}
